import Index from '../../views/partner/Index.vue';
import Register from '../../views/partner/Register.vue';
import ErrorPartnerInvite from '../../components/ErrorPartnerInvite.vue';
import MyData from '../../views/partner/MyData.vue';
import IndicateProfessional from '../../views/partner/IndicateProfessional.vue';
import RegisterShopkeeper from '../../views/partner/RegisterShopkeeper.vue';
import Report from '../../views/partner/Report.vue';
import IndexDashboard from '../../views/partner/Dashboard/Index.vue';
import Ranking from '../../views/partner/Ranking.vue';
import RankingExterno from '../../views/partner/RankingExterno.vue';
import NotActive from '../../views/partner/NotActive.vue';
import SalesPortfolio from '../../views/partner/SalesPortfolio.vue';
import UserTypes from '../../enums/UserTypes';

export default [
  {
    path: '/area-restrita/cadastro/parceiro',
    redirect: '/area-restrita/cadastro/9',
  },
  {
    path: '/area-restrita/parceiro',
    name: 'parceiro',
    component: Index,
    children: [
      {
        path: '/area-restrita/parceiro/meus-dados',
        name: 'parceiro-meus-dados',
        component: MyData,
        meta: { userType: UserTypes.PARTNER },
      },
      {
        path: '/area-restrita/parceiro/cadastrar-lojista',
        name: 'parceiro-cadastrar-lojista',
        component: RegisterShopkeeper,
        meta: { userType: UserTypes.PARTNER },
      },
      {
        path: '/area-restrita/parceiro/indicar-profissional',
        name: 'parceiro-indicar-profissional',
        component: IndicateProfessional,
        meta: { userType: UserTypes.PARTNER },
      },
      {
        path: '/area-restrita/parceiro/relatorio',
        name: 'parceiro-relatorio',
        component: Report,
        meta: { userType: UserTypes.PARTNER },
      },
      {
        path: '/link-youtube/treinamento',
        name: 'link-youtube-treinamento',
        beforeEnter() {
          window.open(
            'https://youtube.com/playlist?list=PLW_y7yl6WbLsvesMkYs62QhGc1Y3VOiHi',
            '_blank'
          );
        },
      },
      {
        path: '/area-restrita/parceiro/ranking',
        name: 'parceiro-ranking',
        component: Ranking,
        meta: { userType: UserTypes.PARTNER },
      },
      {
        path: '/area-restrita/parceiro/ranking-externo',
        name: 'parceiro-externo-ranking',
        component: RankingExterno,
        meta: { userType: UserTypes.PARTNER },
      },
      {
        path: '/area-restrita/parceiro/nao-ativos',
        name: 'nao-ativos',
        component: NotActive,
        meta: { userType: UserTypes.PARTNER },
      },
      {
        path: '/area-restrita/parceiro/dashboard',
        name: 'partner-dashboard',
        component: IndexDashboard,
        meta: { userType: UserTypes.PARTNER },
      },
      {
        path: '/area-restrita/parceiro/portfolio',
        name: 'parceiro-portfolio',
        component: SalesPortfolio,
        meta: { userType: UserTypes.PARTNER },
      },
      {
        path: '/codigo-invalido',
        name: 'codigo-invalido',
        component: ErrorPartnerInvite,
      },
    ],
  },
];
